import React, { useRef, useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import numberFormatter from 'number-formatter'
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form } from "react-bootstrap/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify';
import ReactHtmlParser from 'react-html-parser'; 
import QrScanner from 'components/QrScanner';


import LoaderButton from "./LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

// import "../../node_modules/noty/lib/noty.css";
// import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
// import "./Show.css";

export default function TokenStats({show, ...props}) {
    
  //const file = useRef(null);
  const { id } = useParams();
  const history = useHistory();

  const [stats, setStats] = useState(null);  
  const [isLoading, setIsLoading] = useState(false);  


    useEffect(() => {
        async function onLoad() {
            try {           
                setIsLoading(true)

                loadTokenStats()    

            } catch (e) {
                onError(e);
            } finally {
                setIsLoading(false)
            }
        }

        onLoad();
    }, [show]);
    

    async function loadTokenStats() {
        try {
            setIsLoading(true)

            const stats = await API.get("vivelo", `/etickets/tokens/stats?s=${show._id}`);
            setStats(stats)
            
            return stats
        } finally {
            setIsLoading(false)
        }
    }    
    
    function renderTokensTable() {
        return <Table responsive striped bordered hover variant="dark">
            <tr>
                <th>Tokens</th>
                <th>Disponibles</th>
                <th>Canjeados</th>
            </tr>
            <tr>
                <td>{stats?.total_credits || 0}</td>
                <td>{stats?.balance || 0}</td>
                <td>{stats?.redeemed || 0}</td>
            </tr>
        </Table>
    }



    function renderTokenStats() {        

        return <>
        <div className="container show-tickets">
                <LoaderButton onClick={loadTokenStats} isLoading={isLoading} >Actualizar</LoaderButton>
                <br /><br />
                <>{renderTokensTable()}</>        
        </div> 
        </>
    }
    
    return (        
        show  ? <>
        <div>
            {renderTokenStats()}
        </div>
        </> : null
  );
}